import {DialogSeen} from '../../../../../controls/agyle/clinician/clinitian';
import React from 'react';
import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import moment from 'moment/moment';
import keyPerformanceIndicator from '../../../../../util/timeMarker';
import {getConfig} from '../../../../../util/configUtil';
import {ASSESSMENT_BUTTON_COLOURS} from '../../formsUtil';
import {consultantDictionary} from '../../../../../controls/agyle/clinician/clinitianUtils';

const HandoverForm = (props) => {
    const {t} = useTranslation();
    const isNurseHandover = props.nurseHandover;

    const value = (isNurseHandover ? props.patient?.studies?.edau?.nurseHandover : props.patient?.handover) || {
        who: null,
        when: moment(),
    };

    // Configs
    const currentClinicianTimeToTreatment = getConfig('currentClinicianTimeToTreatment');
    const consultantComponentEnabled = getConfig('consultantComponentEnabled', false);

    const changeHandover = (value) => {
        let data = [{name: isNurseHandover ? 'studies.edau.nurseHandover' : 'handover', value: value}];
        if (!isNurseHandover && value.who) {
            const timestamp = moment().toISOString();
            data.push({
                name: 'currentClinician',
                value: {
                    ...value.who,
                    timestamp,
                },
            });

            if (!isNurseHandover && currentClinicianTimeToTreatment && !_.isNil(value)) {
                keyPerformanceIndicator(
                    data,
                    props.patient,
                    ['firstClinicianSaved'],
                    {
                        when: timestamp,
                        who: value.who,
                    },
                );
            }
        }
        props.onChange(data);
    };

    return (
        <DialogSeen
            nurse={isNurseHandover ? !consultantComponentEnabled : false}
            open={props.open}
            onClose={props.onClose}
            patient={props.patient}
            size="large"
            label={t(isNurseHandover ? 'Nurse Handover' : 'Handover Clinician')}
            allowedConsultants={consultantDictionary[isNurseHandover ? 'nurseForm' : 'handover']}
            disableSave={props.disableSave}
            color={value?.who ? ASSESSMENT_BUTTON_COLOURS.notMandatorySet : ASSESSMENT_BUTTON_COLOURS.notMandatoryEmpty}
            value={value}
            onChange={changeHandover}
            refresh
        />
    );
};

export default HandoverForm;